import type { PoSummary, ReconciliationResult } from "@/shared/api";
import { FlagList } from "./FlagList";
import { LinesTable } from "./LinesTable";
import { PoBreakdown } from "./PoBreakdown";
import { PoTable } from "./PoTable";
import type { ReviewTab } from "../useReviewTabs";

interface ReviewPanelProps {
  active: ReviewTab;
  result: ReconciliationResult;
  threshold: number;
  selectedPo: string | null;
  openOrder: PoSummary | null;
  onSelectPo: (po: string) => void;
  onClosePo: () => void;
}

/** The active review tab's content. A private sub-view of ReviewModule. */
export function ReviewPanelView({
  active,
  result,
  threshold,
  selectedPo,
  openOrder,
  onSelectPo,
  onClosePo,
}: ReviewPanelProps) {
  if (active === "lines") return <LinesTable lines={result.lines} />;
  if (active === "flags") return <FlagList flags={result.flags} />;

  return (
    <>
      <PoTable
        orders={result.purchase_orders}
        threshold={threshold}
        selectedPo={selectedPo}
        onSelect={onSelectPo}
      />
      {openOrder && (
        <PoBreakdown order={openOrder} lines={result.lines} onClose={onClosePo} />
      )}
    </>
  );
}
